module.exports =  {
  TITLE: {
    default: 'Search Hotel|Tens of thousands of hotels in Asia online for reservation',
    detail: '|Hotel Reservation',
  },
  hotel: {
    // 酒店搜索改版新增翻译--英文
    ROOMS: 'Rooms',
    GUESTS: 'Guests',
    CHECK_IN_NUM: 'Guests',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Adult',
    SUFFIX_ADULTS: 'Adults',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Child',
    SUFFIX_CHILDREN: 'Children',
    CHILD_AGE: 'Child\'s Age',
    NO_MATCH_TIPS: 'The below room type does not match the number of rooms and guests you selected.',

    Book_Hotel: 'Book Hotel',
    Select_your_destination: 'Select your destination',
    Please_enter_your_destination: 'Please enter your destination/hotel',
    Booked_up: 'Booked up',
    Hotel_description: 'Hotel description',
    Check_in_date: 'Check-in date',
    Check_out_date: 'Check-out date',
    Sold_out: 'Sold out',
    Non_refundable: 'Non-refundable',
    reserve: 'Book',
    Pay_Online: 'Pay Online',
    Only_rooms_left_before: 'Only ',
    Only_rooms_left_after: ' room(s) left',
    Cancellation_Policy: 'Cancellation Policy',
    See_all_prices_before: 'See all ',
    See_all_prices_after: 'prices',
    Estimated_time_of_arrival: 'Estimated time of arrival',
    make_your_schedule_well_planned: 'Time is for local time zone, please make your schedule well-planned and arrive on time.',
    Hotel_Not_Found: 'Hotel Not Found',
    Please_change_your_search: 'Please change your search',
    Submit_an_application: 'Submit an application',
    Hotel_Confirmation: 'Hotel Confirmation',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Night Stay',
    Hotel_Booking_Number: 'Hotel Booking Number',
    Online_Payment: 'Online Payment',
    The_guest_Room_before: 'The guest[Room',
    The_guest_Room_after: ']',
    Contact_number: 'contact number',
    Bring_all_valid_IDs: 'Please bring all valid IDs of all guests when checking in.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotels Found',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotels Presented (',
    Hotels_Presented_after: ' in total)',
    Please_change_the_dates: 'Room not available on your dates, please change the dates.',
    Login: 'Log in on the APP to book hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nights in total',
    Location: 'Location',
    Pictures: 'Pictures',
    Description: 'Description',
    Policy: 'Policy',
    Check_in_and_check_out_time: 'Check- in and check-out time',
    Check_in_and_Check_out_before: 'Check-in: after ',
    Check_in_and_Check_out_center: 'Check-out: before ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Check-in',
    Check_out_time: 'Check-out',
    Facility_Service: 'Facility & Service',
    Payment_methods: 'Payment methods accepted by the hotel',
    Hotel_Address: 'Hotel Address',
    Pay_online: 'Pay online',
    Pay_offline: 'Pay offline',
    Night_stay_before: '',
    Night_stay_after: '-Night Stay,',
    Rooms_total_before: 'Rooms',
    Rooms_total_after: 'in total',
    Guest_name_must_be_provided: 'The full guest name must be provided.',
    Please_fill_in_your_contact_number: 'Please fill in your contact number',
    Select_estimated_time_of_arrival: 'Select estimated time of arrival',
    Number_of_Rooms: 'Number of Rooms',
    Maximum_guests_per_room_before: 'Maximum ',
    Maximum_guests_per_room_after: ' guests per room',
    Many_Rooms: ' Rooms',
    Service_Fee_Included: '(Tax & Service Fee Included)',
    Last_Name: 'Last Name',
    First_Name: 'First Name ',
    Room: 'Room',
    Additional_Tax: 'Additional Tax',
    Please_inform_the_hotel: 'If you were to arrive beyond estimated arrival time, please inform the hotel in advance.',
    Please_inform_the_hotel_first: 'Arrival at the hotel beyond the estimated arrival time without contacting the hotel in advance will affect the availablity of the room and dinner. Please inform the hotel first to confirm the availablity in such circumstance.',
    Booking_Cancellation: 'Booking Cancellation',
    Reason_of_Cancellation: 'Reason of Cancellation',
    Incorrect_Information_Filled: 'Incorrect Information Filled',
    Itinerary_Changed: 'Itinerary Changed',
    Lower_price_on_other_APP: 'Lower price on other APP',
    Low_quality_hotel: 'Low-quality hotel',
    Book_at_a_lower_price: 'Book at a lower price at the front desk',
    Other: 'Other',
    Please_write_your_reason: 'Please write your reason',
    After_cancellation_done: 'After cancellation done, the payment will be returned to the original payer within 3 working days.',
    How_to_fill_in_the_guest_name: 'How to fill in the guest name',
    It_should_be_exactly_the_same: 'Please provide the guest name in English letters for hotel reservation. It should be exactly the same as the certificate presented when you check in.',
    How_to_fill_in_a_Chinese_name: 'How to fill in a Chinese name:',
    How_to_fill_in_a_English_name: 'How to fill in an English name',
    For_example: 'For example: If your Chinese name is “韩梅梅”, the last name is "Han", the first name is "Meimei".',
    No_specical_characters: 'Do not fill in any numbers or specical characters. ',
    Name_rule_first: 'The last name comes first, the first name follows, and if there is a middle name, it is followed by a space behind the two names. ',
    Name_rule_second: 'For example: Green / Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Pay now',
    Hotel: 'Hotel',
    Check_in: 'Check  in',
    Car: 'Car',
    All_bookings: 'All bookings',
    All: 'All',
    PROMPT: 'Attention',

    Search: 'Search',
    COST_DESCRIPTION: 'Price Detail',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Pay',
    KONW: 'Got it',
    BOOKING_INFORMATION: 'Important Information',
    Book_Now: 'Pay It Now',
    MAP: 'Map',
    CONTACT_INFORMATION: 'Contact Information',
    LOADING: 'Loading...',
    SORT_FILTER: 'Sort/Filter',
    SCREENING: 'Filter',
    SEQUENCE: 'Sort',
    PHONE_ASK: 'Call us',
    ABOVE: '',
    SUBMINT_ORDER: 'Submit',
    OK: 'OK',
    Order_detail: 'Order details',
    BOOKING_INFO: 'Booking Info',
    PAYMENT_AMOUNT: 'Payment Amount',
    Order_time: 'Booking Time',
    ORDER_NUMBERS: 'Booking No',
    PAY_TYPE: 'Payment Method',
    BALANCE: 'Balance',
    CURRENT_BALANCE_BEGIN: 'Balance',
    OVERPLUS_BALANCE_BEGIN: 'Remaining',
    OTHER_PAYMENT: 'Other payment methods',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Click on “Pay It Now” Means You Agree Upon Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Service Agreement》',
    PAYMENT_ORDER: 'Booking Payment',
    Total_pay: 'Amount Due',
    PAY_SUCCESS: 'Payment Accepted',
    CHECK_THE_ORDER: 'Check the Order',
    BACK_TO_INDEX: 'Back to Index',
    CANCEL: 'Cancel',
    RECOMMED: 'Recommend',
    PRICE: 'Price',
    HIGH: 'High',
    LOW: 'Low',
    RESET: 'Reset',
    SELECT_TIME: 'Select Date',
    Hotel_guest: 'The guest',
    Select: 'Please Select',
    Emial_address: 'Please enter email address',
    Booking_explan: 'Booking Information',
    VIEW_MORE: 'View more',
    COLLAPSE: 'Hide',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Check in',
    TOURISM_LEAVE_HOTEL: 'Check out',
    arrive: 'Destination',
    Room_description: 'Room description',
    Meals: 'Meals',
    Room_Type: 'Room Type',
    BOOKING_EXPLANATION: 'Booking Information',
    BOOKING_BUTTON: 'Book',
    REMIND_SUBMIT_ORDER: 'Continue',
    login_now: 'Hotel reservations need to log in, login now?',
    the_real_scene: 'Pictures are for reference only and subject to the real scene.',
    Bed: 'Bed',
    Rooms: 'Room',
    Room_rate: 'Room rate',
    notified_by_SMS: 'After the reservation is successful, you will be notified by SMS',
    email_notifications: 'Used to receive email notifications',
    Booking_deadline: 'Booking deadline',
    Child: 'Child',
    Additional_notes_about_payment: 'Additional notes about payment',
    Nights: 'Nights',
    Minimum_nights_before: 'Minimum',
    Minimum_nights_after: 'nights',
    Size: 'Size',
    Guests: 'Guests',
    Room_rate_1: 'Room rate',
    Tax_service_fee: 'Tax/service fee',
    Pay_now_1: 'Pay now',
    Filter: 'Filter',
    Room_rate2: 'Room rate',
    Show_on_map: 'Show on map',
    Detail: 'Detail',
    Room_Detail: 'Detail',

    TAXES_INCL: 'Taxes incl.',
    SEARCH_EMPTY_TIP: 'Sorry, no availability on your selected date, you can: search alternative dates or hotels',
    severalNight: 'Nights',
    immediateBooking: 'Book Now',
    Refundable: 'Refundable',
    MORE: 'More',
    adultsCompany: 'adults',
    ServiceTerms: 'Services&Terms',
    roomPlan: 'Plan',
    guestRoom: 'Room',
    searchAgain: 'Search again',
    roomNight: 'room/night',

    NAME_TXT: 'Name',
    HOLDER_NAME: 'Card Holder Name',
    EXPIRATION_DATE: 'Expiration Date',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Security Code',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'The 3 digits on the back of the card.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 digits on the front of card',
    ENTER_COMPLETE_CARD_NUM: 'Please enter a complete card number.',
    PLEASE_ENTER_HOLDER_NAME: 'Enter card holder name',
    ENTER_SECURITY_CODE: 'Enter security code',
    ENTER_EXPIRATION_DATE: 'Enter expiration date',
    ROOM_DETAILS: 'Room Details',
    CONDITION_CANCEL: 'Refundable',
    CHOOSE_PAYMENT_METHOD: 'Payment',
    ORDER_TOTAL_LUMP: 'Total Amount',
    CREDIT_CARD_NUM: 'Debit / Credit Card Number',
    MAINLAND_CARD_ONLY: 'Bank card issued outside Mainland China only.',
    SHUT_DOWN: 'Close',
    PROVIDER_FROM_CHINA_BANK: 'Payment service provided by B.O.C',

    COUPON: 'Coupon',
    APPLY_A_COUPON: 'Apply a Coupon',
    NO_USE: 'Not applicable to this deal.',
    Discard: 'Discard',
    REDEEM: 'Redeem',
    EMPTY_COUPON: 'Please enter promotion code',
    NOTICE_COUPON: 'Only one coupon can be redeemed towards every booking; the coupon will be redeemed after booking is submitted.',

    BREAKFAST_INCLUDE: 'breakfast include',
    BREAKFAST_EXCLUDE: 'breakfast exclude',
    DOUBLE_BED: 'double bed',
    TWIN_BED: 'twin bed',
    FREE_CANCEL: 'free cancellation',
    MEALS: 'meals',
    EVALUATION: 'Review',
    FEATURED_REVIEWS: 'Featured Reviews',
    ALL_REVIEWS: 'All Reviews',
    OVERALL_EVALUATION: 'Overall Review',
    ANONYMOUS: 'Anonymous',
    EVAL_GENERAL_LIST_1: 'Poor',
    EVAL_GENERAL_LIST_2: 'Fair',
    EVAL_GENERAL_LIST_3: 'Average',
    EVAL_GENERAL_LIST_4: 'Good',
    EVAL_GENERAL_LIST_5: 'Excellent',
    MAX_IMAGES_WITH_NINE: 'A maximum of 9 pictures can be selected.',
    GRADE_EVAL: 'Please select Overall Rating',
    DISTANCE_FILTER: 'distance close-far',
    EDIT_EVALUATION: 'give comments',
    GO_TO_EVAL: 'give comments',
    EVAL_POINTS_AWARD: 'Good comments can win 1000points,1000 points=10RMB',
    NEARBY_LIKE_HOTEL: 'similar hotel nearby',
    DISTANCE_HOTEL: 'to hotel',
    PLEASE_ENTER_COMMENT: 'comments',
    AWARD_POINTS_TIPS: 'Best comments can get 1000 points 1000=10RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonymous comments will not show your logo and name',
    LOCATION: 'location',
    FACILITY: 'facility',
    SERVICE: 'service',
    HEALTH: 'clean',
    LANGUAGE_SELECT: 'language',
    LIMIT_COMMENT_TXT: 'Review must have 5~2000 characters',
    SHARE_MEDIA: 'Share pics and video',
    SETTLEMENT_FEEL: 'Comments',
    SUBMIT_EVAL: 'Confirm',
    HOTEL_STR: 'Details',
    EVAL_NUM_AFTER: 'review',
  },
  header: {
    SKIING: 'Ski resort',
    header_internal_call: 'Mainland China：',
    header_abroad_call: 'International：',
    header_app_download: 'Mobile App',
    service_telephone: 'Customer Service',
    account_number: 'Account',
    if_bg_user: 'Not a BaiGolf Member?',
    home: 'Home',
    hotel: 'Hotel',
    Golf: 'Golf',
    PLAY_STAY: 'Stay & Play',
    RENT_CAR_HOME: 'Car',
    center_user: 'Member Center',
    header_my_order: 'My Bookings',
    header_notmember_order: 'Guest Bookings',
    header_edit_password: 'Change Password',
    header_logout: 'Log out',
    header_login: 'Log in',
    header_register: 'Register',
    header_point: 'My Points',
    header_all_language: 'All Languages',
    down_load_app: 'Scan QR Code to Download',
    login_discount_tip: 'Log in to earn bonus and enjoy your exclusive benefits'
  },
  footer: {
    footer_partner: 'Partners',
    footer_about_us: 'About Us',
    footer_about_baigolf: 'About BaiGolf.com',
    footer_privacy_policy: 'BaiGolf.com Privacy Policy',
    footer_use_of_terms: 'BaiGolf.com Service Terms',
    footer_contact_us: 'Contact Us',
    footer_sitemap: 'Sitemap',
    footer_use_of_question: 'FAQ',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'APP Download',
    footer_sina_weibo: 'Sina Weibo',
    footer_tencent_weibo: 'Tencent microblog',
    footer_share_to: 'Share',
    copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Copyright ',
    copyright2: 'Yue ICP Registration No.14070002',
    news_center: 'News Center',
    about_baigolf: 'About BaiGolf',
    help: 'Help',
    management_system: 'BG Golf Management System (BGMS)',
    wechat_official_account: 'WeChat Official Account',
    download_baiGolf_app: 'Download BaiGolf App',
    privacy_policy: 'Privacy Policy',
    use_of_terms: 'Service Terms',
    footer_integral: 'Points Policy',
    footer_reserve: 'Booking Policy',
    footer_abroad_call: 'International',
    footer_internal_call: 'Mainland China'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en_us.js